import React from 'react';
import {ThemeContextInterfaceWithToggle} from 'types/themes/themeContextInterface';

const CemitThemeContext = React.createContext<ThemeContextInterfaceWithToggle>();
export default CemitThemeContext;
